<template>
  <div class="row mt-0">
    <div class="col-12 col-lg-6">
      <atom-select
        v-model="siteAccessFilter.type"
        title="Report type"
        placeholder="Select type"
        label="name"
        :option="siteAccessTypeOption"
        :is-clearable="false"
        @input="onChangeType($event)"
      />
    </div>
    <div class="col-lg-6"></div>
    <div v-if="siteAccessFilter.type.id === '1'" class="col-12 mt-1">
      <atom-multi-select
        v-model="siteAccessFilter.ntdcList"
        title="NTDC ID"
        placeholder="Select NTDC ID"
        label="text"
        :option="siteAccessNtdcIdOption"
        :isClearable="false"
      ></atom-multi-select>
    </div>
    <div
      v-if="siteAccessFilter.type.id === '2'"
      class="col-12 col-md-8 mt-1"
    >
      <atom-select
        v-model="siteAccessFilter.ntdc"
        title="NTDC ID"
        placeholder="Select NTDC ID"
        label="text"
        :option="siteAccessNtdcIdOption"
        :isClearable="false"
      ></atom-select>
    </div>
    <div
      v-if="siteAccessFilter.type.id === '2'"
      class="col-12 col-md-4 mt-1"
    >
      <atom-multi-select
        v-model="siteAccessFilter.status"
        title="Status"
        placeholder="All Status"
        label="name"
        :option="siteAccessStatusOption"
      ></atom-multi-select>
    </div>
  </div>
</template>

<script>
import AtomSelect from "@/components/atoms/AtomSelect.vue"
import AtomInput from "@/components/atoms/AtomInput.vue"
import AtomMultiSelect from "@/components/atoms/AtomMultiSelect.vue"

export default {
  name: "MoleculeReportFilterSiteAccess",
  components: { AtomSelect, AtomInput, AtomMultiSelect },
  props: {
    value: {
      type: Object,
      required: true,
    },
    siteAccessStatusOption: {
      type: Array,
      required: true,
    },
    siteAccessTypeOption: {
      type: Array,
      required: true,
    },
    siteAccessNtdcIdOption: {
      type: Array,
      required: true,
    },
  },

  computed: {
    siteAccessFilter: {
      get() {
        return this.value
      },
      set(newValue) {
        this.$emit("input", newValue)
      },
    },
  },
  methods: {
    onChangeType(data) {
      this.siteAccessFilter.ntdcList = null

      this.siteAccessFilter.ntdc = null
      this.siteAccessFilter.status = null

      if (data.id === "2") {
        this.siteAccessFilter.ntdc = this.siteAccessNtdcIdOption?.[0]
      }
    },
  },
}
</script>

<style></style>
